const RESPONSE = {
  SUCCESS: {
    CODE: 200,
    MSG: '성공',
    MAIL: {
      CODE: '0',
    },
  },
  FAIL: {
    CODE: 400,
    MSG: '실패',
  },
  NO_QUESTION: {
    CODE: -100,
    MSG: '더 이상 풀 문제 없음.',
  },
  TOKEN_EXPIRED: {
    CODE: 401,
    MSG: '토큰 만료',
  },
  SERVER_ERROR: {
    CODE: 500,
    MSG: '서버 오류',
  },
};

export default RESPONSE;



// WEBPACK FOOTER //
// ./src/constants/response.js